/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import './style.css'
import {
  MixedWidget2,
  MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
} from '../../../_metronic/partials/widgets'
import { registerLicense } from '@syncfusion/ej2-base';
import {ScheduleComponent, Inject,Day,Week,Month,Agenda, EventSettingsModel} from '@syncfusion/ej2-react-schedule'

const DashboardPage: FC = () => (
  // private  localdata : EventSettingsModel={
  //   dataSource: [{
  //     EndTime: new Date(2022,0,11,6,30,0,0,0),
  //     StartDate: new Date(2022, 0, 11, 10,0,0,0,0)
  //   }]
  // };
  <div>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-6 h-100'>
        <MixedWidget11
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='175px'
        />
       
      </div>
      
      <div className='col-xxl-6 h-100'>
      <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        
      </div>
    </div>
    {/* <div className='row gy-5 g-xl-8'>
      <iframe src="https://calendar.google.com/calendar/embed?src=28ff2a2d93693a564bdc1248dc51b4d0edc7c1682c2fbe0ce450fb828aa0aa1f%40group.calendar.google.com&ctz=Africa%2FAbidjan" style={{border: 0 ,}} frameBorder="0" scrolling="no" width="800" height="600"></iframe>
    </div> */}
<div className='row gy-5 g-xl-8 mt-10'></div>
    <ScheduleComponent>
      <Inject services={[Day,Week,Month,Agenda]}/>
    </ScheduleComponent>
  </div>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>Appraisal</PageTitle>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
